<template>
  <div>
    <b-card title="Görsel">
      <b-img
        v-if="itemData.image"
        :src="imageUrl + '/media/news/' + itemData.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('news')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="570"
      :resize="true"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import { BButton, BCard, BImg } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage, BCard, BButton, BImg,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['news/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'news') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'news-image.jpg',
          folder: 'news',
          ratio: 1200 / 800,
          type: 'news',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'news') {
        this.itemData.image = item.image
        this.itemData.thumb = item.thumb
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
